// page-builder events

import track from '../lib/tracking/track';

window.pageBuilderTracking = (data) => {
  let { detail } = data;

  // only handle custEv_pageDataAvailable
  if(detail.event === "custEv_pageDataAvailable") {
    let { detail } = data;

    let eventName = 'page_viewed';
    let payload = {
      // set in _javascript_packs
      "lang": window.locale,
      "label": detail.templateName,
      "pageLocation": window.location.pathname
    };

    track(eventName, payload);
  // video related
  } else if(detail.event === "custEv_videoLoad" || detail.event === "custEv_videoPlay") {
    let { blade } = data;

    let eventName = detail.event === "custEv_videoLoad" ? 'video_loaded' : 'video_played'
    let payload = {
      // set in _javascript_packs
      "lang": window.locale,
      "label": blade.video?.videoName,
      "pageLocation": `page_builder_${blade.video.videoId}`
    };

    track(eventName, payload);
  // custEv_contentClick fires for ANY link click in a blade (text/image/dropdown/cta),
  // not just CTAs -- only track it as cta_clicked when the resolved link is actually a
  // CTA (data-link-type e.g. "primary cta" / "secondary cta"), so plain content link
  // clicks aren't mislabeled.
  } else if(detail.event === "custEv_contentClick") {
    let { blade } = data;
    let link = blade?.module?.link;

    if (link?.type?.toLowerCase().includes('cta')) {
      let payload = {
        // set in _javascript_packs
        "lang": window.locale,
        "label": link.text,
        "ctaHref": link.url,
        "ctaType": link.type,
        "pageLocation": window.location.pathname
      };

      track('cta_clicked', payload);
    }
  // custEv_internalDriverClick is dispatched on the clicked element itself (bubbles,
  // but not composed -- won't cross a shadow root boundary), for internal links whose
  // href carries a `d=` tracking param. Unlike custEv_contentClick it has no blade/module
  // context at all.
  } else if(detail.event === "custEv_internalDriverClick") {
    let payload = {
      // set in _javascript_packs
      "lang": window.locale,
      "label": detail.calltoActionText,
      "ctaHref": detail.eventLbl,
      "pageLocation": window.location.pathname
    };

    track('cta_clicked', payload);
  }
}

document.addEventListener('www_track', (e) => {
  try {
    if(window.dataLayer) {
      window.dataLayer.push(e.detail);
    }
  } catch {
    console.log('Could not push event detail to GTM');
  }

  // blade lives inside detail.blade per PBC's dispatch payload, not as a
  // sibling of detail -- hoisted here so callers can destructure `blade`
  // straight off `data` (pre-existing convention for the video branch below).
  let data = {
    detail: e.detail,
    blade: e.detail.blade,
  }

  window.pageBuilderTracking(data);
});

